import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useMainStore } from './pinia';

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// import guide from '@/demo/components/guide.vue';
// import { onMounted, onBeforeUnmount } from 'vue';
const store = useMainStore();

const gotoVerity = () => {
  window.open('https://beian.miit.gov.cn/');
};

// onMounted(() => {
// document.body.style.setProperty("--el-color-primary", "#5754F9");
// 鼠标移动到按钮上方时显示的颜色，默认蓝色，可以和primary设置的颜色不一样
// document.body.style.setProperty("--el-color-primary-light-3", "#5754F9");
// document.body.style.setProperty('--el-button-border-color', '#5754F9');
// // success
// document.body.style.setProperty('--el-color-success', '#67C23A');
// document.body.style.setProperty('--el-color-success-light-3', '#67C23A');
// // danger
// document.body.style.setProperty('--el-color-danger', '#FAB7C9');
// document.body.style.setProperty('--el-color-danger-light-3', '#FAB7C9');
// warning
// document.body.style.setProperty("--el-color-warning", "#FFDF73");
// document.body.style.setProperty("--el-color-warning-light-3", "#FFDF73");
// });

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createElementVNode("p", {
      class: "view-footer",
      onClick: gotoVerity
    }, " 粤ICP备2024161950号-4 ")
  ], 64))
}
}

})